<template>
  <div v-if="layout" class="confirm ">
    <div @click="Cancel" :class="{ show: show }" class="confirm_layout"></div>
    <div :class="{ show: show }" class="confirm_wrapper ">
      <div v-if="header" class="confirm_header ">
        <h1>{{ header }}</h1>
      </div>
      <div class="confirm_body">
        <div class="confirm_body_wrap " v-html="body"></div>
        <input type="text" v-model="answer" v-if="text && !number" />
      </div>
      <div class="confirm_actions notification_body_actions">
        <button @click="Agree" class="action -red">{{ agree }}</button>
        <button @click="Cancel">{{ cancel }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Confirm",
  data: () => ({
    layout: false,
    show: false,
    text: false,
    answer: "",
    resolve: null,
    reject: null,
    body: null,
    header: null,
    data: null,
    cancel: null,
    agree: null,
    number: null
  }),
  methods: {
    open(options) {
      this.layout = true;
      this.header = options.header;
      this.body = options.body;
      this.text = options.text;
      this.number = options.number;
      this.answer = options.value;
      this.cancel = options.cancel || "Cancel";
      this.agree = options.agree || "OK";
      setTimeout(() => (this.show = true), 100);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    Agree() {
      if (this.text) {
        if (this.answer.length < 1)
          return this.$store.dispatch("SEND_NOTIFY", {
            head: "Ошибка",
            body: "Введите Ваш ответ"
          });
      }
      this.resolve(this.answer);
      this.Close();
    },
    Close() {
      this.show = false;
      setTimeout(() => (this.layout = false), 600);
      setTimeout(() => (this.text = false), 600);
    },
    Cancel() {
      this.reject(false);
      this.Close();
    }
  }
};
</script>
